import Vue from 'vue';
import Router from 'vue-router';
import Search from '@/pages/Search';
import List from '@/pages/List';
import List2 from '@/pages/List2';

Vue.use(Router);

export default new Router({
    //base: '/v1/search',
    mode: process.env.ROUTER_MODE,
    routes: [
        {
            path: '/v1/search',
            component: Search,
            name: 'search'
        },
        {
            path: '/v1/list',
            component: List,
            name: 'list'
        }
        // ,
        // {
        //     path: '/v1/list2',
        //     component: List2,
        //     name: 'list2'
        // }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js